import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { iconShape } from '../../../../../../../../../../shared/types';

const iconContainerClasses = [
  'bg-brand',
  'flex',
  'items-center',
  'justify-center',
  'rounded-lg',
  'size-8',
  'text-white',
].join(' ');

const WorkspaceLogo = ({ logo }) => (
  <div className={iconContainerClasses}>
    <FontAwesomeIcon icon={logo} />
  </div>
);

WorkspaceLogo.propTypes = {
  logo: iconShape.isRequired,
};

export default WorkspaceLogo;
